'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = undefined;

var _functional = require('../../utils/functional');

var classes = {
  activeDrawerClass: 'drw-Drawer-active'
};

var Drawer = exports.Drawer = {
  _isOpen: false,

  init: function init(_ref) {
    var key = _ref.key;

    this.key = key;
    this.els = {
      trigger: (0, _functional.getElement)('[data-module-drawers-trigger=' + key + ']'),
      drawer: (0, _functional.getElement)('[data-module-drawers-drawer=' + key + ']'),
      close: (0, _functional.getElement)('[data-module-drawers-close=' + key + ']')
    };
  },

  get isOpen() {
    return this._isOpen;
  },

  set isOpen(val) {
    this._isOpen = val;
    this.els.drawer.classList.toggle(classes.activeDrawerClass, val);
  }
};